export const HighlightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.04706 11.9651L13 4.80233L10.6706 2.5L3.68235 8.51163M7.04706 11.9651L2 13.5M7.04706 11.9651L3.68235 8.51163M2 13.5L3.68235 8.51163M2 13.5H13"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
